import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';
import { CartManager } from '../utils/CartManager';

export const CartIcon = () => {
  const [cartCount, setCartCount] = useState(0);
  
  useEffect(() => {
    // Initial count
    setCartCount(CartManager.getCartItemCount());
    
    // Listen for cart updates
    const handleCartUpdate = (event) => {
      setCartCount(event.detail.items.length);
    };
    
    window.addEventListener('cartUpdated', handleCartUpdate);
    
    return () => {
      window.removeEventListener('cartUpdated', handleCartUpdate);
    };
  }, []);
  
  return (
    <Link to="/buy" className="relative p-2 text-gray-700 hover:text-red-500 transition">
      <ShoppingCart className="w-6 h-6" />
      {cartCount > 0 && (
        <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
          {cartCount}
        </span>
      )}
    </Link>
  );
};